import { combineReducers } from 'redux';
import {
  FILTERS_TOGGLE_VISIBILITY,
  FILTERS_SELECT,
  FILTERS_SET_CATEGORIES
} from '../actions/filtersAction';

export default function (initialState = {
  hidden: false,
  selectedFilter: 'all',
  filterTitles: {
    all: 'All Discussions',
    yours: 'Your questions',
    unread: 'Unread',
    unanswered: 'Unanswered',
    followed: 'Followed',
    search: 'Search…'
  },
  categories: []
}, action) {

  switch (action.type) {
    case FILTERS_SELECT: {
      return { ...initialState, selectedFilter: action.payload}
    }

    case FILTERS_SET_CATEGORIES: {
      if (action.payload) {
        let new_filters_titles = {};
        action.payload.map(category => {
          new_filters_titles[category.id] = category.name;
        });

        return {
          ...initialState,
          categories: action.payload,
          filterTitles: {
            ...initialState.filterTitles,
            ...new_filters_titles
          }
        };
      }
      break;
    }

    case FILTERS_TOGGLE_VISIBILITY: {
      return {
        ...initialState,
        hidden: (initialState.hidden === true ? false : true)
      };
    }
  }

  return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/filtersReducer.jsx